<script>
export default {
  methods: {
    distanceBetween (lat1, lon1, lat2, lon2, unit) {
      let rlat1 = Math.PI * lat1 / 180
      let rlat2 = Math.PI * lat2 / 180
      let theta = lon1 - lon2
      let rtheta = Math.PI * theta / 180
      let dist = Math.sin(rlat1) * Math.sin(rlat2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.cos(rtheta)
      dist = Math.acos(dist)
      dist = dist * 180 / Math.PI
      dist = dist * 60 * 1.1515
      if (unit === 'K') {
        dist = dist * 1.609344
      }
      if (unit === 'N') {
        dist = dist * 0.8684
      }
      return dist
    },
    getDistance (gps) {
      const curPosLat = this.$store.state.currentPosition.lat
      const curPosLong = this.$store.state.currentPosition.lng

      return Math.round(this.distanceBetween(curPosLat, curPosLong, gps.lat, gps.lng, 'K'))
    }
  }
}
</script>
